<template>
  <v-card>
    <div class="color-picker-title" :style="`background-color: ${valueWatch}`">
      <h1>{{ valueWatch.toUpperCase() }}</h1>
    </div>
    <div class="color-picker-content">
      <swatches
        v-model="valueWatch"
        :colors="colors"
        :inline="inline"
        :shapes="shapes"
        :swatch-style="swatchStyle" />
    </div>
  </v-card>
</template>

<script>
import Swatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.min.css'

export default {
  name: 'ColorPicker',
  components: { Swatches },
  props: {
    value: {
      default: '#9e28b5'
    }
  },
  data () {
    return {
      valueWatch: this.value,
      colors: ['#9e28b5', '#8546b1', '#410a5e', '#999999', '#000000'],
      inline: true,
      shapes: 'squares',
      swatchStyle: {
        borderRadius: '2px'
      }
    }
  },
  watch: {
    valueWatch () {
      this.$emit('input', this.valueWatch)
    }
  }
}
</script>

<style lang="scss" scoped>
.color-picker-title {
  color: white;
  padding: 16px;

  h1 {
    font-weight: 500;
  }
}
</style>
